import {
  emailSchema,
  emailUI,
  phoneSchema,
  phoneUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['applicants--contact-info-title'];
const DESC_TEXT = content['applicants--contact-info-description'];

const setRequired = ({ certifierRole }, index) =>
  index === 0 && certifierRole === 'applicant';

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.applicant),
    applicantPhone: phoneUI(),
    applicantEmailAddress: emailUI({ required: setRequired }),
  },
  schema: {
    type: 'object',
    required: ['applicantPhone'],
    properties: {
      applicantPhone: phoneSchema,
      applicantEmailAddress: emailSchema,
    },
  },
};
